















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { BoletoDTO } from '@/interfaces/Boleto.interface'
import HTTP from '@/plugins/axios'
moment.locale('es-MX')

@Component
export default class PrintResumenCortesCaja extends Vue {
  @Prop({ type: Object })
  private printInfo!: any
  @Prop({ type: Boolean })
  private printNow!: boolean

  private name: string = 'PrintResumenCortesCaja'
  private catBoleto: any[] = []
  private typeInfo: string = null
  private isCopy: boolean = false
  private isCopyMSG: string = 'ESTO ES UNA COPIA SIN VALOR'

  private totalCASH: number = 0
  private totalCARD: number = 0
  private totalEND: number = 0

  private styleTHInfo: string = 'border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'
  private styleTHInfoBlank: string = 'border-style:solid;border-color:black;border-width:1px;'
  private styleTHFecha: string = 'border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'
  private styleTH: string = 'width:10%;border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'
  private styleTD: string = 'border-style:solid;border-color:black;border-width:1px;'
  private styleTHCategoria: string = 'width: 100%;border-style:solid;border-color:black;border-width:1px;background: #283593;color: #FFF;'

  @Watch('printInfo')
  private async watchPrintInfo (v: any) {
    console.log('watchPrintInfo :: ', v)
    await this.gCatBoletos()
    this.isCopy = false
    this.totalCASH = 0
    this.totalCARD = 0
    this.totalEND = 0
    if (v) {
      await v.items.forEach((item: any) => {
        this.totalCASH = parseFloat(item.cashOnSiteCashUser) + parseFloat(this.totalCASH.toString())
        this.totalCARD = parseFloat(item.cashOnSiteCardUser) + parseFloat(this.totalCARD.toString())
        this.totalEND = parseFloat(item.cashOnSiteUser) + parseFloat(this.totalEND.toString())
      })
      // @ts-ignore: Unreachable code error
      await this.$htmlToPaper('printMeCorteCajaResume')
      console.log('Finish Print')
    }
  }

  private agroupBoletoImpresion (boletos: BoletoDTO[]) {
    console.log('agroupBoletoImpresion :: ', boletos)
    let res: any[] = this.catBoleto
    console.log('agroupBoletoImpresion :: ', res)
    res.forEach((cat: any) => {
      cat.quantity = 0
      cat.total = 0
      boletos.forEach((bole: any) => {
        if (cat.name === bole.name) {
          cat.quantity += 1
        }
      })
      // @ts-ignore: Unreachable code error
      cat.total = parseFloat(cat.quantity * cat.cost)
    })

    return res
  }

  private gCatBoletos () {
    HTTP.get('respaldo/reportes/boleto/')
      .then((response) => {
        console.log('gCatBoletos :: response :: ', response.data)
        this.catBoleto = response.data
      })
      .catch((e) => {
        console.log('gCatBoletos :: catch :: ', e.response.data)
      })
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gCatBoletos()
  }
}
